const env =
  window.location.hostname.split('.')[0] === "staging"
    ? 'staging'
    : window.location.hostname.split('.')[0] === "test"
      ? 'test'
      : ['localhost', '127.0.0.1', '0.0.0.0', '192.168.86.39', 'dev.genoplot.com'].includes(window.location.hostname)
        ? 'development'
        : 'production'

let isVite = false;
try {
isVite = import.meta.env ? true : false;
}
catch(err) {}
let envm = isVite ? import.meta.env : process.env;
const awsConfig = {
  Auth: {
    region: envm.VITE_aws_cognito_region,
    userPoolId: envm.VITE_aws_user_pools_id,
    userPoolWebClientId: envm.VITE_aws_user_pools_web_client_id,
    identityPoolId: envm.VITE_aws_cognito_identity_pool_id,

    oauth: {
      domain: envm.VITE_authDomain,
      scope: ['email', 'profile', 'openid', 'aws.cognito.signin.user.admin'],
      redirectSignIn:
        env === 'development'
          ? 'http://localhost:8080/'
          : env === 'staging'
            ? 'https://staging.genoplot.com/signin'
            : 'https://genoplot.com/signin',
      redirectSignOut:
        env === 'development'
          ? 'http://localhost:8080/'
          : env === 'staging'
            ? 'https://staging.genoplot.com/'
            : 'https://genoplot.com/',
      responseType: 'code',
        socialProviders: ['Google', 'Apple', 'Facebook']
    }
  }
}

export default awsConfig

